export default {
    read_all: 'Pogledajte sve ocene',
}
